import { useEffect, useState } from "react";
import { getAllProvincias } from "../../../services/provincia.service";
import { getAllDepartamentos } from "../../../services/departamento.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { ProvinciaList } from "../../../modules/provincia/ProvinciaList";

export const ProvinciaPage = () => {
  const [busqueda, setBusqueda] = useState("");
  const [provincias, setProvincias] = useState(null);
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  
  useEffect(() => {
    obtenerProvincias();
  }, []);

  const obtenerProvincias = async () => {
    try {
      const [provinciasData, departamentosData] = await Promise.all([
        getAllProvincias(),
        getAllDepartamentos().catch(() => []),
      ]);

      // Crear un mapa de departamentos por ID para búsqueda rápida
      const departamentosMap = {};
      if (departamentosData && departamentosData.length > 0) {
        departamentosData.forEach((depto) => {
          departamentosMap[depto.idDepartamento] = depto;
        });
      }

      // Enriquecer las provincias con información del departamento
      const provinciasConDepartamento = provinciasData.map((provincia) => {
        const departamento = departamentosMap[provincia.idDepartamento];
        return {
          ...provincia,
          departamento: departamento || null,
        };
      });

      setProvincias(provinciasConDepartamento);
    } catch (err) {
      console.log("Error al obtener provincias:", err);
    }
  };

  return (
    <ContenedorPageTemplate objetos={provincias} dirIcono={DIR_ICON_MAT} titulo="Lista de Provincias">
      <div className="fila flex gap-4 justify-between items-center mb-2 w-full">
        <div className="flex flex-col justify-end items-center">
          <p className="total">
            Total de provincias: <span>{provincias?.length || 0}</span>
          </p>
        </div>
      </div>
      <ProvinciaList provincias={provincias} onRefresh={obtenerProvincias} />
    </ContenedorPageTemplate>
  );
};